import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { stepKeys } from '../../model/matTour.model';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [MatDividerModule, TourMatMenuModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
public supportEmail = 'pcsupport@jacksondawson.com'
public stepKeys = stepKeys
openUrl(url:string){
  window.open(url);
}
openOutlook(){
  const subject = '';
  const body = '';
  const outlookUrl = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(this.supportEmail)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.open(outlookUrl, '_blank');
}
}
